<script lang="ts" setup>
import { onMounted, reactive, watch } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import DropdownUsuarios from "@/components/Dropdowns/DropdownUsuarios.vue";

import * as service from "@/services/permissoesService";

const controle = reactive({
  usuarioId: null as number | null,
  permissoes: [] as service.PermissaoUsuario[],
  notificacao: { exibir: false, mensagem: "", tipo: "success" },
  status: "",
  erro: "",
});

watch(() => controle.usuarioId, (novoId) => {
  if (novoId) carregarPermissoes(novoId);
  else controle.permissoes = [];
});

function carregarPermissoes(usuarioId: number) {
  controle.status = "Carregando...";
  controle.erro = "";
  service.obterPermissoesUsuario(usuarioId)
    .then(r => { controle.permissoes = r; controle.status = ""; })
    .catch(e => { controle.erro = e.message || String(e); controle.status = ""; });
}

function togglePermissao(perm: service.PermissaoUsuario) {
  perm.possui = !perm.possui;
}

function marcarTodas(valor: boolean) {
  controle.permissoes.forEach(p => p.possui = valor);
}

async function salvar() {
  if (!controle.usuarioId) return;

  controle.erro = "";
  controle.status = "Salvando...";

  const ids = controle.permissoes.filter(p => p.possui).map(p => p.permissaoId);

  try {
    await service.salvarPermissoesUsuario({ usuarioId: controle.usuarioId, permissaoIds: ids });
    controle.status = "";
    controle.notificacao = { exibir: true, mensagem: "Permissões salvas com sucesso!", tipo: "success" };
  } catch (e: any) {
    controle.status = "";
    controle.erro = e.message || String(e);
  }
}
</script>

<template>
  <BreadCrumb PageTitle="Permissões" SubTitle="Gestão de Acesso" />

  <Notificacao
    :exibir="controle.notificacao.exibir"
    :mensagem="controle.notificacao.mensagem"
    :tipo="(controle.notificacao.tipo as any)"
    @onFechou="controle.notificacao.exibir = false" />

  <div class="card">
    <div class="card-body">

      <div class="row g-3 mb-4">
        <div class="col-md-4">
          <label class="form-label fw-semibold">Selecione o Usuário</label>
          <DropdownUsuarios v-model="controle.usuarioId" />
        </div>
        <div class="col-md-8 d-flex align-items-end gap-2" v-if="controle.permissoes.length">
          <button class="btn btn-outline-success btn-sm" @click="marcarTodas(true)">
            <i class="flaticon-check"></i> Marcar todas
          </button>
          <button class="btn btn-outline-danger btn-sm" @click="marcarTodas(false)">
            <i class="flaticon-close"></i> Desmarcar todas
          </button>
        </div>
      </div>

      <div class="text-muted" v-if="controle.status">{{ controle.status }}</div>
      <div class="text-danger" v-if="controle.erro">{{ controle.erro }}</div>

      <div v-if="!controle.usuarioId && !controle.status" class="text-muted text-center py-4">
        Selecione um usuário para gerenciar suas permissões.
      </div>

      <div class="row g-3" v-if="controle.permissoes.length">
        <div
          v-for="perm in controle.permissoes"
          :key="perm.permissaoId"
          class="col-md-3 col-sm-4 col-6">
          <div
            class="border rounded p-3 h-100 d-flex align-items-center gap-2 cursor-pointer permissao-card"
            :class="{ 'bg-success bg-opacity-10 border-success': perm.possui }"
            @click="togglePermissao(perm)"
            style="cursor:pointer;">
            <i
              class="fs-5"
              :class="perm.possui ? 'flaticon-check text-success' : 'flaticon-close text-secondary'">
            </i>
            <span class="fw-semibold">{{ perm.descricao }}</span>
          </div>
        </div>
      </div>

    </div>

    <div class="card-footer" v-if="controle.permissoes.length">
      <div class="d-flex justify-content-end gap-2">
        <RouterLink class="btn btn-secondary btn-sm" to="/">Fechar</RouterLink>
        <button class="btn btn-primary btn-sm" @click="salvar()">
          <i class="flaticon-check"></i> Salvar Permissões
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.permissao-card:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
